import styled from '@emotion/styled';
import { css } from '@styled-system/css';
import { useAtom } from 'jotai';
import React, { useCallback, useEffect, useState } from 'react';

import { Flex, Icon, TextField } from '~/components/blocks';
import { patientPageInfoState } from '~/state/patient/atoms';
import { throttle } from '~/utils/throttle';

const Root = styled(Flex)(({ theme }) =>
  css({
    alignItems: 'center',
    backgroundColor: theme.colors.background.default,
    padding: `0 ${theme.space.m}`,
    borderRadius: theme.radii.default,
    border: theme.borders.default,
    fontWeight: theme.fontWeights.default,
  }),
);

const throttleInput = throttle(500);

export const SearchBox = () => {
  const [searchWord, setSearchWord] = useState('');
  const [state, setState] = useAtom(patientPageInfoState);
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const searchWord = e.target.value;

      setSearchWord(searchWord);
      throttleInput(() => {
        setState((_state) => ({ ..._state, searchWord, page: 1 }));
      });
    },
    [setState],
  );

  useEffect(() => {
    setSearchWord(state.searchWord || '');
  }, [state.searchWord]);

  return (
    <Root>
      <Icon size="l" icon="search" />
      <TextField
        appearance="search"
        placeholder="患者名・電話番号で検索"
        value={searchWord || ''}
        onChange={handleChange}
      />
    </Root>
  );
};
